export default __webpack_public_path__ + "static/media/bg-1.24866a33.jpg";